<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Customer Details</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="detailsForm">
        <fieldset>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label>Type</label>
                    <div class="mvd_form-control">
                        Individual
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Customer Number</label>
                    <div class="mvd_form-control">
                        {{ customerNumberId }}
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>SSN</label>
                    <div class="mvd_form-control">
                        {{ ssn | ssn }}
                    </div>
                </div>
				<div *ngIf="canEdit" class="col-sm-2 mvd_form-group">
					<label for="doNotUse">Do Not Use</label>
					<input type="checkbox" formControlName="doNotUse">
				</div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label>Date of Birth</label>
                    <p-calendar [showIcon]="true" formControlName="dateOfBirth" [maxDate]='maxDate'></p-calendar>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Deceased Date</label>
                    <p-calendar [showIcon]="true" [showButtonBar]="true" formControlName="deceasedDate" [maxDate]='maxDate'></p-calendar>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Updated By</label>
                    <div class="mvd_form-control">
                         {{individualDetails.biometric.updatedBy}} 
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!(detailsForm.valid)" [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="saveDetails()"></mvm-spinner-btn>
    </div>
</div>